
/**
 * Created by rlopez on 11/28/16.
 */
// ActionDetailsView.js

import {Model,View} from 'backbone'
import template from '../../../../../templates/dashboard/connections/details/action-forms.ejs';
import SelectItemModalView from 'common-views/SelectItemModalView.js';
import RestService from 'RestService.js';
import NotificationService from 'NotificationService.js';
import * as gridModels from '../action-type/ActionGridModels.js';
import util from '../../../../service/util/Util.js';
import constants from '../../../../constants/Constants.js';
import Immutable from 'immutable';

import _ from 'lodash';

class ActionForms extends View {
    initialize(opts){

        this.template = template;
        this.actionService = opts.actionService;

        this.events = {
            "click button[name=addSend], button[name=addReturn]"          : "itemNew",
            "click button[name=removeSend], button[name=removeReturn]"    : "itemRemove",
            "click button[name=upSend], button[name=upReturn]"            : "itemUp",
            "click button[name=downSend], button[name=downReturn]"        : "itemDown",
            "click button[name=autoSend], button[name=autoReturn]"        : "autoComplete"
        };
        this.onResize();
        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    changeTableName(){
        return this.actionService.changeTableName.apply(this.actionService, arguments);
    }

    changeDistinct(){
        return this.actionService.changeDistinct.apply(this.actionService, arguments);
    }

    itemNew(){
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model, '.ui-jqgrid-bdiv');
        return this.actionService.itemNew.apply(this.actionService, arguments);
    }

    itemRemove(){
        util.saveGridScrollPos(this.model, '.ui-jqgrid-bdiv');
        this.actionService.itemRemove.apply(this.actionService, arguments);
        this.reorderFieldsParameters(this.model.get('currentActionDetails'));
        return;
    }

    itemDown(){
        this.actionService.itemDown.apply(this.actionService, arguments);
        this.reorderFieldsParameters(this.model.get('currentActionDetails'));
        return;
    }

    itemUp(){
        this.actionService.itemUp.apply(this.actionService, arguments);
        this.reorderFieldsParameters(this.model.get('currentActionDetails'));
        return;
    }

    autoComplete(){
        return this.actionService.autoComplete.apply(this.actionService, arguments);
    }



    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    // Method that renders an scroll in the grid in order to navigate the same on small screens.
    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    renderGridsByType(){
        console.log("Re rendering Grid");
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        $('.read , .insert , .update').addClass('hide');
        // PF-2113 temporary hack. Upstream code is confusing connection action type connection type
        if (currentModel.Type.length < 2) {
            // Convert to connection forms read
            currentModel.Type += "0";
        }

        switch (currentModel.Type){
            case constants.CONNECTION_FORMS_READ:
                this.renderParametersGrid(
                    gridModels.GRID_FORMS_PARAMETERS_MODEL_SHOWN_OPERATION,
                    gridModels.GRID_FORMS_PARAMETER_HEADERS,
                    constants.CONNECTION_SELECT_SEND_CONTAINER,
                    gridModels.GRID_FORMS_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_FORMS_PARAMETER_HEADERS,
                    constants.CONNECTION_SELECT_RETURN_CONTAINER,
                );
                $('.read').removeClass('hide');
                break;
            case constants.CONNECTION_FORMS_INSERT:
                this.renderParametersGrid(
                    gridModels.GRID_FORMS_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_FORMS_PARAMETER_HEADERS,
                    constants.CONNECTION_INSERT_SEND_CONTAINER
                );
                $('.insert').removeClass('hide');
                break;
            case constants.CONNECTION_FORMS_UPDATE:
                this.renderParametersGrid(
                    gridModels.GRID_FORMS_PARAMETERS_MODEL_HIDDEN_OPERATION,
                    gridModels.GRID_FORMS_PARAMETER_HEADERS,
                    constants.CONNECTION_UPDATE_SEND_CONTAINER
                );
                $('.update').removeClass('hide');
                break;
        }
        this.resizeGrid();
    }

    renderParametersGrid(colSendModel,colSendNames,colSendContainer,colReturnModel,colReturnNames,colReturnContainer){
        let currentModel = this.model.get('currentActionDetails'),
            self=this;
        console.log("Current Action Details",currentModel);
        let sendItemsToRender=currentModel.ActionXML.Action.Send.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Send.Parameter
            : [currentModel.ActionXML.Action.Send.Parameter];
        let returnItemsToRender=currentModel.ActionXML.Action.Receive.Parameter instanceof Array
            ? currentModel.ActionXML.Action.Receive.Parameter
            : [currentModel.ActionXML.Action.Receive.Parameter];

        let gridSendObject = util.getGridObject(this,{
            colModel:colSendModel,
            colNames:colSendNames,
            autowidth:true,
            height: 300,
            scrollOffset:0});
        let gridReturnObject = util.getGridObject(this,{
            colModel:colReturnModel,
            colNames:colReturnNames,
            autowidth:true,
            height: 300,
            scrollOffset:0});
        $(colSendContainer).jqGrid(gridSendObject);
        $(colReturnContainer).jqGrid(gridReturnObject);
        _.forEach(sendItemsToRender, (field, index) => {
            self.fillNewRow(colSendContainer,index, field['_fixedValue'],field['_id'] ,field['_isFixed'],
                field['_name'],field['_operation'] ,field['_value'], this.getFieldName(field['_value']))
        });
        _.forEach(returnItemsToRender, (field, index) => {
            self.fillNewRow(colReturnContainer,index, field['_fixedValue'],field['_id'] ,field['_isFixed'],
                field['_name'],field['_operation'] ,field['_value'], this.getFieldName(field['_value']))
        });
    }

    getFieldName(id) {
         const currentModel = this.model.get('currentActionDetails');
 
         if (currentModel.ActionXML.Action.Fields === "") {
             return null;
         }
         
         const field = currentModel.ActionXML.Action.Fields.Field.find(f => {
             return f._id === id;
         });
 
         return field ? (field['_Meta'].toLowerCase() === 'true' ? 'Meta - ' : '') + field['_Name'] : null;
     }

    onDoubleClickRow(rowId,iRow,iCol,e) {
        if(iCol !== constants.FORM_FIELD_COLUMN){
            return;
        }
        let currentModel=this.model.get('currentActionDetails');
        this.model.set('currentGridSelector',`#${e.currentTarget.id}`,{silent:true});
        this.model.set('currentRowId',rowId,{silent:true});

        RestService.getFormFields(constants.DEFAULT_GROUP_ID,currentModel.FormGUID,this.processFormItems.bind(this));
    }

    processFormItems(isError,result){
        let currentGrid=this.model.get('currentGridSelector'),
            currentModel=this.model.get('currentActionDetails'),
            currentRowId=this.model.get('currentRowId'),
            isSend = currentGrid.indexOf('Send') > 0,
            fieldId;
                
        const updateInsertAction = Immutable.Set([
            constants.CONNECTION_FORMS_INSERT,
            constants.CONNECTION_FORMS_UPDATE]);
        const isUpdateOrInsert = updateInsertAction.contains(currentModel.Type);

        let filteredResult;
        
        if (isUpdateOrInsert){ //PF-2908, Meta fields will be filtered to only include 'instanceName'
            filteredResult = result.filter((v, k) => v['@Meta'].toLowerCase() !=='true' || (v['@Name'] === 'instanceName'));
        }else{
            filteredResult = result;
        }        

        let items = filteredResult.map((item) => {
            return {
                label: (item['@Meta'].toLowerCase() === 'true' ? "Meta - " : "") + item['@Name'],
                items: item
            }
        });

        let fieldSelectionModalView = new SelectItemModalView({model: new Model({items: items})});
        fieldSelectionModalView.render().then(selectedItem => {
            if (selectedItem) {
                if (currentModel.ActionXML.Action.Fields === "") {
                    currentModel.ActionXML.Action.Fields = {
                        Field: []
                    }
                }
                
                if (isSend) {
                    currentModel.ActionXML.Action.Fields.Field.some((field, index) => {
                        if (isSend) {
                            if (field['_IsOut'] === 'false' && field['_id'] ===
                                currentModel.ActionXML.Action.Send.Parameter[currentRowId]["_value"]) {
                                fieldId = index;
                                return true;
                            }
                        }
                    });

                    if (!fieldId) {
                        currentModel.ActionXML.Action.Fields.Field.push({
                            _id: selectedItem.items['@id'],
                            _Name: selectedItem.items['@Name'],
                            _DataType: selectedItem.items['@DataType'],
                            _InternalFlag: selectedItem.items['@InternalFlag'],
                            _Meta: selectedItem.items['@Meta'].toLowerCase(),
                            _oldId: selectedItem.items['@oldId'],
                            _IsOut: 'false'
                        })
                    }

                    currentModel.ActionXML.Action.Send.Parameter[currentRowId]["_name"] = selectedItem.label;
                    currentModel.ActionXML.Action.Send.Parameter[currentRowId]["_value"] = selectedItem.items['@id'];
                }
                else {
                    currentModel.ActionXML.Action.Fields.Field.some((field, index) => {
                        if (field['_IsOut'] === 'true' && field['_id'] ===
                            currentModel.ActionXML.Action.Receive.Parameter[currentRowId]["_value"]) {
                            fieldId = index;
                            return;
                        }
                    });

                    if (!fieldId) {
                        currentModel.ActionXML.Action.Fields.Field.push({
                            _id: selectedItem.items['@id'],
                            _Name: selectedItem.items['@Name'],
                            _DataType: selectedItem.items['@DataType'],
                            _InternalFlag: selectedItem.items['@InternalFlag'],
                            _Meta: selectedItem.items['@Meta'].toLowerCase(),
                            _oldId: selectedItem.items['@oldId'],
                            _IsOut: 'true'
                        })
                    }
                    
                    currentModel.ActionXML.Action.Receive.Parameter[currentRowId]["_name"] = selectedItem.label;
                    currentModel.ActionXML.Action.Receive.Parameter[currentRowId]["_value"] = selectedItem.items['@id'];
                }

                if (fieldId) {
                    currentModel.ActionXML.Action.Fields.Field[fieldId]["_id"] = selectedItem.items['@id'];
                    currentModel.ActionXML.Action.Fields.Field[fieldId]["_Name"] = selectedItem.items['@Name'];
                    currentModel.ActionXML.Action.Fields.Field[fieldId]["_DataType"] = selectedItem.items['@DataType'];
                    currentModel.ActionXML.Action.Fields.Field[fieldId]["_InternalFlag"] = selectedItem.items['@InternalFlag'];
                    currentModel.ActionXML.Action.Fields.Field[fieldId]["_Meta"] = selectedItem.items['@Meta'].toLowerCase();
                    currentModel.ActionXML.Action.Fields.Field[fieldId]["_oldId"] = selectedItem.items['@oldId'];
                }                

                this.reorderFieldsParameters(currentModel);
                this.model.set('currentActionDetails',currentModel,{silent:true});
                this.model.set('hasChanges',true,{silent:true});
                this.model.trigger('change');
            }
        }).catch((errMsg) => {
            console.log(errMsg);
            NotificationService.error(errMsg);
        });
    }

    reorderFieldsParameters(currentModel){
        if (currentModel.ActionXML.Action.Fields.Field){
            let _fieldsParamOut = [];
            let _newIdx = 0;
            //Order OUT fields in the same order that Receive parameters
            $.each(currentModel.ActionXML.Action.Receive.Parameter, (_idx, _param) => {
                var _currentFieldParamOut = currentModel.ActionXML.Action.Fields.Field.filter((v,k) => v['_id'] === _param['_value'] && v['_IsOut'] === 'true');
                if (_currentFieldParamOut.length > 0){
                    _fieldsParamOut.push(_currentFieldParamOut[0]);
                }
            });

            let _fieldsParamIn = [];
            //Order IN fields in the same order that Send parameters
            $.each(currentModel.ActionXML.Action.Send.Parameter, (_idx, _param) => {
                let _currentFieldParamIn = currentModel.ActionXML.Action.Fields.Field.filter((v,k) => v['_id'] === _param['_value'] && v['_IsOut'] === 'false');                
                if (_currentFieldParamIn.length > 0){
                    _fieldsParamIn.push(_currentFieldParamIn[0]);
                }
            });

            currentModel.ActionXML.Action.Fields.Field = [..._fieldsParamOut, ..._fieldsParamIn];
        }
    }

    afterSaveCell(rowId, cellName, value, iRow, iCol){
        let currentGrid=this.model.get('currentGridSelector'),
            currentModel=this.model.get('currentActionDetails'),
            isSend = currentGrid.indexOf('Send') > 0;

        console.log('Current Grid',currentGrid);
        console.log("Editing",rowId);
        console.log("Editing",cellName);
        console.log("Editing",value);
        if(isSend){
            currentModel.ActionXML.Action.Send.Parameter[rowId][cellName] = value;
        }
        else{
            currentModel.ActionXML.Action.Receive.Parameter[rowId][cellName] = value;
        }
        this.model.set('currentActionDetails',currentModel,{silent:true});
        this.model.set('hasChanges',true,{silent:true});
        this.model.trigger('change');
        console.log("Model After Save Cell",currentModel);
    }

    onSelectRow(){}

    onCellSelect(){}

    fillNewRow(grid,index, _fixedValue,_id,_isFixed,_name, _operation, _value, displayName) {
        $(grid).addRowData(index, {
            '_fixedValue': _fixedValue,
            '_id': _id,
            '_isFixed': _isFixed,
            '_name': _name,
            '_operation': _operation,
            '_value': _value,
            'displayName': displayName
        });
    }

    setRow(rowId, e){
        console.log('before select row',e);
        $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
        this.model.set('currentGridSelector',`#${e.currentTarget.id}`,{silent:true});
    }//

    afterEditCell(rowId, cellName, value, iRow, iCol){
        let self=this;
        $("#"+iRow+"_"+cellName).bind('blur',function(){
            $(self.model.get('currentGridSelector')).saveCell(iRow,iCol);
        });
    }

    render(){
        console.log("Rendering Grids");
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.renderGridsByType();
        util.setGridScrollPos(this.model, '.ui-jqgrid-bdiv');
        this.delegateEvents();
        return this;
    }

}

export default ActionForms;